import {  takeEvery } from 'redux-saga/effects'

import { PERFORM_LOGIN, LOGIN_AUTH, REMOVED_TOKENS_SUCCESS, GET_STATION_LIST } from '../../components/authentication/AuthenticationConstants';
import { fetchAccessToken, loginAuth, clearAuthResponse, getStationList  } from './authentication';
import { getOffersDataSearch, getOfferData, submitVTORequest, getEmpRequestsBatch, getEmployeeShiftData, getRequestsBundle, submitOffers, submitConfirmRequestData, updateSlotsRequest, updateOfferStatusRequest, submitReqResolutionData, getMandoWorkLocations, getChangeLogData, getStationListData, submitEditCutOff, getVtoForecastData, getVtoForecastIntervalsData, getPotentialSavings } from '../../components/VTO/VTOSaga';
import { getDepartmentServicesData, getOTGroupDataSaga, getSBGroupDataSaga } from '../../components/home-page/home-page-store/HomePageSaga';
import { GET_DEPARTMENT_SERVICES, GET_OT_GROUP, GET_SB_GROUP, } from '../../components/home-page/home-page-store/HomePageConstants';
import { vtoConstants } from "../../components/VTO/VTOConstants";
import { getOvertimeData, confirmOvertimeDecision, getOTSkillsDataSaga } from '../../components/OT-Comp/OvertimeSaga';
import { overtimeConstants } from '../../components/OT-Comp/OvertimeConstants';

export function* watchAuthentication() {
    yield takeEvery(PERFORM_LOGIN, fetchAccessToken);
    yield takeEvery(LOGIN_AUTH, loginAuth);
    yield takeEvery(REMOVED_TOKENS_SUCCESS, clearAuthResponse);
    yield takeEvery(GET_STATION_LIST, getStationList);
}

export function* watchHomePage() {
    yield takeEvery(GET_DEPARTMENT_SERVICES, getDepartmentServicesData);
    yield takeEvery(GET_OT_GROUP, getOTGroupDataSaga);
    yield takeEvery(GET_SB_GROUP, getSBGroupDataSaga);
}

export function* watchVTO() {
    yield takeEvery(vtoConstants.OFFERS_TABLE_BATCH, getOffersDataSearch);
    yield takeEvery(vtoConstants.OFFER_DETAIL, getOfferData);
    yield takeEvery(vtoConstants.SUBMIT_REQUEST, submitVTORequest);
    yield takeEvery(vtoConstants.GET_EMP_REQ, getEmpRequestsBatch);
    yield takeEvery(vtoConstants.GET_EMP_SHIFT , getEmployeeShiftData);
    yield takeEvery(vtoConstants.GET_REQ_BUNDLE, getRequestsBundle);
    yield takeEvery(vtoConstants.SUBMIT_OFFERS_BATCH, submitOffers);
    yield takeEvery(vtoConstants.SUBMIT_CONFIRM_REQUEST, submitConfirmRequestData);
    yield takeEvery(vtoConstants.UPDATE_SLOTS, updateSlotsRequest);
    yield takeEvery(vtoConstants.UPDATE_STATUS, updateOfferStatusRequest);
    yield takeEvery(vtoConstants.SUBMIT_REQ_RESOLUTION, submitReqResolutionData);
    yield takeEvery(vtoConstants.GET_WORK_LOCATIONS, getMandoWorkLocations);
    yield takeEvery(vtoConstants.GET_CHANGE_LOG, getChangeLogData);
    yield takeEvery(vtoConstants.GET_VTO_STATION_LIST, getStationListData);
    yield takeEvery(vtoConstants.SUBMIT_EDIT_CUT_OFF, submitEditCutOff);
    yield takeEvery(vtoConstants.GET_FORECAST, getVtoForecastData);
    yield takeEvery(vtoConstants.GET_FORECAST_INTERVALS, getVtoForecastIntervalsData);
    yield takeEvery(vtoConstants.GET_POTENTIAL_SAVINGS, getPotentialSavings);
}

export function* watchOvertime() {
    yield takeEvery(overtimeConstants.GET_OVERTIME_DATA, getOvertimeData);
    yield takeEvery(overtimeConstants.CONFIRM_DECISION, confirmOvertimeDecision);
    yield takeEvery(overtimeConstants.GET_OT_SKILLS, getOTSkillsDataSaga);
}

